import moment from "moment";
import {useState} from "react";
import {useSwipeable} from "react-swipeable";

export const generateMapBackground = (location) => {
   if (location) {
      const encodedAddress = encodeURIComponent(`${location.address}, ${location.postal}`);
      const mapBackgroundUrl = `https://maps.googleapis.com/maps/api/staticmap?center=${encodedAddress}&zoom=13&size=1200x600&key=${process.env.REACT_APP_GOOGLE_MAPS_API_KEY}`;
      return {backgroundImage: 'url(' + mapBackgroundUrl + ')'};
   }
};

export const setSendDateUTC = (date) => {
   // Manipular a data enviada para que fica com as mesmas horas mas em UTC para enviar para o servidor
   // Desta forma a data é sempre uniforme independentemente do fuso horário do utilizador

   let dateOffsetMinutes = date.getTimezoneOffset();
   const copy = new Date(date.getTime());
   copy.setMinutes(copy.getMinutes() - dateOffsetMinutes);

   return copy.toISOString();
}

export const isFilled = (value) => {
   return value !== '' && value !== null && typeof value !== 'undefined';
}

export const isLeagueEditionEnding = (leagueEditionEndDate) => {
   const editionEndDate = moment(leagueEditionEndDate);

   if (!editionEndDate.isValid()) {
      return false;
   }

   const sendLimit = editionEndDate.endOf("day").add(24, "hours");

   return moment().isSameOrBefore(sendLimit);
}

export const isFullAbsence = (enrollment, gameWeekStartDate, gameWeekEndDate) => {
   return gameWeekStartDate >= new Date(enrollment.absence_start_date) && gameWeekEndDate <= new Date(enrollment.absence_end_date);
}

export const doesAbsenceOverlap = (startDate1, endDate1, startDate2, endDate2) => {
   return startDate1 <= endDate2 && startDate2 <= endDate1;
}

export const isWithinAbsencePeriod = (date, absenceStartDate, absenceEndDate) => {
   return date >= absenceStartDate && date <= absenceEndDate;
}

export const useSwipeableHook = (nTabs) => {
   const [activeTabIndex, setActiveTabIndex] = useState(0);

   const handlers = useSwipeable({
      delta: 20,
      preventScrollOnSwipe: true,
      onSwipedLeft: (eventData) => {
         if (activeTabIndex < nTabs - 1) {
            setActiveTabIndex(activeTabIndex + 1);
         }
      },
      onSwipedRight: (eventData) => {
         if (activeTabIndex > 0) {
            setActiveTabIndex(activeTabIndex - 1);
         }
      },
   });

   return { handlers, activeTabIndex, setActiveTabIndex };
};

// Usado para colocar a data no DateTimePicker para a data de início ou fim da edição dependendo se a data atual for antes do início da edição ou depois do fim da edição respetivamente
// Nos restantes casos, retorna a data atual
export const checkDate = (date, leagueEditionStartDate, leagueEditionEndDate) => {
   if (date > leagueEditionEndDate) {
      leagueEditionEndDate.setHours(date.getHours());
      leagueEditionEndDate.setMinutes(date.getMinutes());
      return leagueEditionEndDate;
   }

   if(date < leagueEditionStartDate) {
      leagueEditionStartDate.setHours(date.getHours());
      leagueEditionStartDate.setMinutes(date.getMinutes());
      return leagueEditionStartDate
   }

   return new Date();
}

export const DEFAULT_LANGUAGE = 'en';

export const languages = {
   pt: {nativeName: 'Português'},
   en: {nativeName: 'English'}
};

export const supportedLanguageCodes = Object.keys(languages);

export const normalizeLanguage = (language) => {
   const languageCode = (language || '').toString().trim().split(/[-_]/)[0].toLowerCase();

   return supportedLanguageCodes.includes(languageCode) ? languageCode : DEFAULT_LANGUAGE;
};
